import { Modal, Spinner, SpinnerSize } from '@fluentui/react';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import { _getAdvKeyImageForPreview } from '../../../../service/StudyViewerService';
import { isMobile } from 'react-device-detect';

const ManageAdvKeyImagePreview = (props) => {

  const [imageError, setImageError] = useState(false);
  const [imageErrorMsg, setImageErrorMsg] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [loading, setLoading] = useState(false);

  const Containerstyles=  {
    root:{
      backgroundColor: 'rgb(22, 21, 20, 0.7)'
   },
    main:{
      boxSizing: "border-box",
      borderRadius: "10px 10px 10px 10px",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
      border: "1px solid #4B4B4B",
    },
  }

  const { t } = useTranslation();

  useEffect(()=>{
    previewAdvKeyImageFunc();
    // console.log(props.imageURL)
  },[]);


  const previewAdvKeyImageFunc = async() =>{
    let studyId = props.studyId;
    let imageId = props.imageId;
    setLoading(true);
    try{
      const response = await _getAdvKeyImageForPreview(studyId, imageId);
      console.log(response);
      const contentType = response.headers.get('Content-Type');
        if (response.status===200) {
          console.log('image found');
          setImageURL("data:image/jpeg;base64, "+response.data.data);
          setImageErrorMsg("");
          setImageError(false);
          console.log("image url", imageURL);
        }else{
          setImageError(true);
          setImageErrorMsg("No image found");
        }
        setLoading(false);
    }catch(error){
      setImageErrorMsg("Unknown error occurred while retrieving image.");
      setLoading(false);
      setImageError(true);
    }
  }


    return (
      <>
          <Modal
            isOpen={props.previewAdvKeyImage}
            titleAriaId="id"
            scrollableContentClassName={"stop-scroll-for-modal"}
            styles={Containerstyles}
          >
            {/* fixed 500px overflowed the phone screen (modal shifted, header
                cut off). Constrain to the viewport width on mobile. */}
            <div style={{ width: isMobile ? "92vw" : "500px", maxWidth: "500px" }}>
              <ModalHeader
                handleCancel={() => props.setPreviewAdvKeyImage(false)}
                updatedModal = {true}
                heading = "Preview Key Image"
              />
              {loading ? (
              <div
                style={{
                  padding: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  margin:"20px"
                }}
              >
                <Spinner size={SpinnerSize.large} />
                </div>
              ) :
                <div style={{margin:"15px 0px 20px 0px"}}>
                  {imageError === false ?
                    <img src={imageURL} id="previewKeyImage_" alt="_keyImage" style={{width:"100%",height:"350px"}}/> : <span style={{color:"white"}}>{imageErrorMsg}</span>
                  }
                </div>
              }
              <ModalFooter
                DefaultButtonList={[
                      {
                      title: t("key-image.cancel"),
                      onclick: () => props.setPreviewAdvKeyImage(false),
                      },
                  ]}
              />
            </div>
          </Modal>
        </>
      );
}

export default ManageAdvKeyImagePreview